module.exports = __webpack_public_path__ + "img/hr-solar-panel-shadow-overlay.34375e19.png";